import { Component } from 'react';
import { withTranslation } from '../../lib/translate';
import Basket from '../../lib/basket';

class CheckoutYoco extends Component {

    componentDidMount() {
        Basket.createYocoOrder('yoco')
    }
    render() {
        return <></>
    }
}
export default withTranslation(CheckoutYoco);
